import { camelCase } from 'lodash';
import { CamelCase, Exact, PascalCase, ValueOf } from 'type-fest';

function camelCaseToPascalCase<T extends string | number | symbol>(val: T): PascalCase<T> {
  if (typeof val === 'symbol' || typeof val === 'number') {
    return val as PascalCase<T>;
  }
  return `${val[0].toUpperCase()}${val.slice(1)}` as PascalCase<T>;
}

export const convertEnumToGqlEnum =
  <GqlEnum extends Exact<Record<PascalCase<TSEnum>, any>, GqlEnum>, TSEnum extends CamelCase<keyof GqlEnum>>(
    gqlEnum: GqlEnum,
  ) =>
  (val: TSEnum) =>
    gqlEnum[camelCaseToPascalCase(val) as any as keyof GqlEnum];

export const convertGqlEnumToEnum =
  <GqlEnum extends Exact<Record<PascalCase<TSEnum>, string>, GqlEnum>, TSEnum extends CamelCase<keyof GqlEnum>>(
    _gqlEnum: GqlEnum,
  ) =>
  (val: ValueOf<GqlEnum>) =>
    camelCase(val as string) as TSEnum;
